
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/web",
      function () {
        return require("private-next-pages/docs/link/web.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/web"])
      });
    }
  